import '../../../styles/Home/schedule.scss';
import ScheduleCard from './ScheduleCard';

const dayOneTrackA = {
  heading: 'Day 1 - Track A',
  events: [
    { time: '09:00 AM', name: 'Git Happens - Workshop' },
    { time: '09:30 AM', name: 'Reel and Post Competition' },
    { time: '09:45 AM', name: 'Grow with Tech Communities' },
    { time: '10:10 AM', name: 'GitHub and Argo CD' },
    { time: '10:40 AM', name: 'Automating AWS Infrastructure using Terraform and GitLab CI/CD' },
    { time: '11:10 AM', name: 'Introduction to Web' },
    { time: '11:40 AM', name: 'Cascading Brilliance: Unleashing the Power of CSS' },
    { time: '12:10 PM', name: 'Meme Workshop' },
    { time: '12:40 PM', name: 'Resume Design' },
    { time: '01:10 PM', name: 'UI/UX is not graphics design' }
  ]
}
const dayOneTrackB = {
  heading: 'Day 1 - Track B',
  events: [
    { time: '09:00 AM', name: 'Git Happens - Workshop' },
    { time: '09:30 AM', name: 'Reel and Post Competition' },
    { time: '09:45 AM', name: 'Grow with Tech Communities' },
    { time: '10:10 AM', name: 'GitHub and Argo CD' },
    { time: '10:40 AM', name: 'Automating AWS Infrastructure using Terraform and GitLab CI/CD' },
    { time: '11:10 AM', name: 'Machine Learning 101' },
    { time: '11:40 AM', name: 'Classification Workshop' },
    { time: '12:10 PM', name: 'Octocat drawing' },
    { time: '12:40 PM', name: 'Power of Remote Work' },
    { time: '01:10 PM', name: 'Prompt Design' }
  ]
}

const dayTwoSchedule = {
  heading: 'Day 2',
  events: [
    { time: '09:00 AM', name: 'Opening' },
    { time: '09:10 AM', name: 'Solution Building' },
    { time: '12:30 PM', name: 'Judgement Round & final Evaluation' },
    { time: '01:15 PM', name: 'Prize Distributions' },
    { time: '01:30 PM', name: 'Crowd Grouop Photo Time' },
    { time: '01:40 PM', name: 'Networking & Pack Up' }
  ]
}

const Schedule = () => {
  return (
    <div id="schedule" class="schedule">
      <h1 className="schedule__heading">
        Schedule
      </h1>

      <div class="schedule__cards">
        <ScheduleCard schedule={dayOneTrackA} />
        <ScheduleCard schedule={dayOneTrackB} />
        <ScheduleCard schedule={dayTwoSchedule} />
      </div>
    </div>
  )
}

export default Schedule;